import React, {FC, Fragment} from 'react';
import {label} from "../../service";
import {CheckBox} from "../common/checkbox";
import {TourItemInsurance} from "../../types/tourItem";

interface InsurancesProps {
    onChange: (id: number) => void
    insurances: TourItemInsurance[],
    values: number[],
    checkoutPrice: string
    duration: number
}

export const CheckoutInsurances: FC<InsurancesProps> = ({onChange,insurances,values, checkoutPrice,duration}) => {

    const getInsurancePrice = (item: any) => {
        let formatString = `${label('Free')}`;
        if (+(item.price) > 0) {
            formatString = `€${Math.round(item.price * 100) / 100}`;
        }
        return formatString;
    }

    return (
        <Fragment>
            {
                insurances.map((item) => {
                    return (
                        <CheckBox key={item.id}
                                  onChange={() => {
                                      onChange(item.id)
                                  }}
                                  label={item.name}
                                  name={item.name}
                                  price={getInsurancePrice(item)}
                                  checked = {values.includes(item.id)}
                                  tooltip={item.info}
                        />
                    )
                })
            }
        </Fragment>
    )
}